import { Pipe, PipeTransform, inject, DOCUMENT } from '@angular/core';

@Pipe({
  name: 'stripHtml',
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  #document = inject(DOCUMENT);

  transform(value = '') {
    const div = this.#document.createElement('div');
    div.innerHTML = value;
    return div.textContent || div.innerText || '';
  }
}
